enum PageNames {
    LOAN_OFFICER_PAGE = 'loanOfficerPage',
    REVIEW_PAGE = 'reviewPage',
}

enum FeatureFlags {
    LOAN_OFFICER_REVIEWS = 'LOAN_OFFICER_REVIEWS',
    NO_PREQUAL_LINK_SHAREABLE_LO_LINKS = 'NO_PREQUAL_LINK_SHAREABLE_LO_LINKS',
}

const featureFlagList = Object.keys(FeatureFlags);

type FeatureFlagObject = {
    [value in PageNames]: {
        [value in FeatureFlags]: string[];
    };
};

type FeatureList = {
    [value in PageNames]: FeatureFlags[];
};

const featureList: FeatureList = {
    [PageNames.LOAN_OFFICER_PAGE]: [
        FeatureFlags.LOAN_OFFICER_REVIEWS,
        FeatureFlags.NO_PREQUAL_LINK_SHAREABLE_LO_LINKS,
    ],
    [PageNames.REVIEW_PAGE]: [FeatureFlags.LOAN_OFFICER_REVIEWS],
};

const featureTreatments: FeatureFlagObject = {
    [PageNames.LOAN_OFFICER_PAGE]: {
        [FeatureFlags.LOAN_OFFICER_REVIEWS]: ['on', 'off'],
        [FeatureFlags.NO_PREQUAL_LINK_SHAREABLE_LO_LINKS]: ['on', 'off'],
    },
    [PageNames.REVIEW_PAGE]: {
        [FeatureFlags.LOAN_OFFICER_REVIEWS]: ['on', 'off'],
        [FeatureFlags.NO_PREQUAL_LINK_SHAREABLE_LO_LINKS]: ['on', 'off'],
    },
};

export { PageNames, FeatureFlags, featureFlagList, featureList, featureTreatments };
